import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
//Mui components
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
//Style
import { useStyles } from 'components/sheets/AccountImportSheet/AccountImportSheet.style';
// PCP Components
import ImportAccounDiffTable from 'components/tables/ImportAccounDiffTable';
//Actions
import ItemAction from 'actions/ItemAction.js';
// Locales
import translate from 'locales/i18n';
import AccountStore from 'stores/AccountStore';
//Utils
import { testKeyUnicity, getItems } from 'components/sheets/AccountImportSheet/AccountImport.utils';

const AccountImportKeySelect = ({ keys, selectedAccount, accountDiffStats, setAccountDiffStats, matchings, setKeys, importType, keyUnique, setKeyUnique }) => {

    const classes = useStyles();

    const [keysError, setKeysError] = useState('');
    const [isLoadingDiff, setIsLoadingDiff] = useState(AccountStore.isLoadingDiff());

    const onAccountStoreChanges = () => {
        setAccountDiffStats(AccountStore.getAccountDiffStats());
        setIsLoadingDiff(AccountStore.isLoadingDiff());
    };

    useEffect(() => {
        AccountStore.addChangeListener(onAccountStoreChanges);
        return () => AccountStore.removeChangeListener(onAccountStoreChanges);
    }, []);

    return (
        <div className={classes.keyStepContainer}>
            <div className={classes.keyChipContainer}>
                <div className={classes.textAvailableFields}>Champs disponibles pour créer la clé : </div>
                {Object.keys(matchings).map(m => matchings[m].header === '' ?
                    null :
                    <Chip
                        size='small'
                        key={m} label={m}
                        onClick={() => {
                            if (!keys.includes(m)) {
                                const newKeys = keys.concat([m]);
                                setKeys(newKeys);
                            }
                        }}
                        className={classes.keyChip}
                        color={keys.includes(m) ? 'primary' : 'default'}
                    />)}
            </div>
            <div className={classes.keyContainer}>
                <div className={classes.textAvailableFields}>La clé est : </div>
                <div className={classes.chosenKeyChipContainer}>
                    {keys.map(k =>
                        <Chip
                            color='primary'
                            size='small'
                            key={k}
                            label={k}
                            onDelete={() => {
                                const newKeys = keys.filter(elem => elem !== k);
                                setKeys(newKeys);
                            }}
                            className={classes.keyChip}
                            style={{ marginTop: '5px', marginBottom: '5px' }}
                        />)}
                </div>
            </div>
            {keyUnique ? <div className={classes.infoText}> La clé est bien unique </div> : keysError ? <div className={classes.keysErrorText}>{keysError}</div> : null}
            <Button
                variant='contained'
                color='primary'
                onClick={() => {
                    setKeysError('');
                    if (keys.length > 0) {
                        const isKeyUnique = testKeyUnicity(keys, getItems(matchings, keys, importType === 'account' ? 'keys':importType, true));
                        if (isKeyUnique.length === 0) {
                            importType === 'account' ? ItemAction.diffImportItems(keys, getItems(matchings, keys, importType, true), selectedAccount.id) : setKeyUnique(true);
                        } else {
                            setKeysError('Des clés sont non uniques : ' + isKeyUnique.join(', '));
                            setKeyUnique(false);
                        }
                    } else {
                        setKeysError('Vous devez choisir au moins une clé');
                        setKeyUnique(false);
                    }
                }}
                align='center'
                style={{ marginTop: '10px' }}
            >
                {translate.i18n('TEST_KEY')}
            </Button>
            {accountDiffStats || isLoadingDiff ?
                <div className={classes.resultKeyTestContainer}>
                    {isLoadingDiff ?
                        <div className={classes.loaderContainer}><CircularProgress /></div>
                        :
                        accountDiffStats ?
                            <div>
                                <div>
                                    {`Il y a ${accountDiffStats.articlesOnlyCount} articles en base qui n'ont pas eu de matchs.`}
                                </div>
                                <div>
                                    {`Il y a ${accountDiffStats.inputOnlyCount} articles dans le fichier d'import qui n'ont pas eu de matchs.`}
                                </div>
                                <div>
                                    {`Il y a ${accountDiffStats.singleMatchesCount} articles dans le fichier d'import qui ont eu un match avec un article en base.`}
                                </div>
                                <div>
                                    {`Il y a ${accountDiffStats.multiMatchesCount} articles dans le fichier d'import qui ont eu plus d'un match avec des articles en base.`}
                                </div>
                            </div>
                            :
                            null}
                </div>
                :
                null
            }
            {accountDiffStats ?
                <div className={classes.resultKeyTestTableContainer}>
                    {accountDiffStats.articlesOnlyKeys.length !== 0 ?
                        <ImportAccounDiffTable keys={keys}
                            title={'Articles en base qui n\'ont pas eu de matchs'}
                            items={accountDiffStats.articlesOnlyKeys}
                        />
                        :
                        null
                    }
                    {accountDiffStats.inputOnlyKeys.length !== 0 ?
                        <ImportAccounDiffTable keys={keys}
                            title={'Articles dans le fichier d\'import qui n\'ont pas eu de matchs'}
                            items={accountDiffStats.inputOnlyKeys}
                        />
                        :
                        null
                    }
                    {accountDiffStats.singleMatchKeys.length !== 0 ?
                        <ImportAccounDiffTable keys={keys}
                            title={'Articles dans le fichier d\'import qui ont eu un match avec un article en base'}
                            items={accountDiffStats.singleMatchKeys}
                        />
                        :
                        null
                    }
                    {accountDiffStats.multiMatchKeys.length !== 0 ?
                        <ImportAccounDiffTable keys={keys}
                            title={'Articles dans le fichier d\'import qui ont eu plus d\'un match avec des articles en base'}
                            items={accountDiffStats.multiMatchKeys}
                        />
                        :
                        null
                    }
                </div>
                :
                null
            }
        </div>
    );
};

AccountImportKeySelect.propTypes = {
    accountDiffStats: PropTypes.object,
    importType: PropTypes.string,
    keys: PropTypes.array,
    keyUnique: PropTypes.bool,
    matchings: PropTypes.object,
    selectedAccount: PropTypes.object,
    setAccountDiffStats: PropTypes.func,
    setKeys: PropTypes.func,
    setKeyUnique: PropTypes.func
};

export default AccountImportKeySelect;
